import { REEBELO_TZ_NAME } from '@lambda/reebelo';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import settings from '@/settings';

dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

export const checkDateEquality = (date: string | null | undefined) => {
  const today = dayjs().tz(REEBELO_TZ_NAME[settings.store]);

  const isSameDate = today.isSame(date, 'date');

  return { today, isSameDate };
};

export const calculateDifferenceUntilEndOfDay = () => {
  const day = dayjs().tz(REEBELO_TZ_NAME[settings.store]);
  const endOfDay = day.endOf('day');
  const hours = endOfDay.hour() - day.hour();
  const minutes = endOfDay.minute() - day.minute();

  if (hours < 1) return `${minutes} minutes left`;
  const timeUnit = hours > 1 ? 'hours' : 'hour';

  return `${hours + 1} ${timeUnit} left`;
};

export const isPriceRangeFilterChanged = (
  priceRange: { min?: string; max?: string },
  priceRangeValue: { min: number; max: number },
) => {
  if (priceRange.min == null && !priceRange.max == null) return false;
  if (Number(priceRange.max) === 0 && Number(priceRange.min) === 0)
    return false;
  if (
    Number(priceRange.min) >= priceRangeValue.min &&
    Number(priceRange.max) <= priceRangeValue.max
  )
    return true;
  if (
    Number(priceRange.min) === 0 &&
    Number(priceRange.max) <= priceRangeValue.max
  )
    return true;

  return false;
};
